import React from 'react';
import { urlMap, urlConstructor } from 'routes/urlMap';
import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import { NavLink } from '../components';

export const PostJobLink = (props) => {
  const path = urlMap.CREATE_MODULAR_ORDER;

  return (
    <NavLink
      {...props}
      icon={faCirclePlus}
      textPath="navbar.new_job"
      displayPath="/job_requests/new"
      url={urlConstructor(path)}
      name="post-jobs"
    />
  );
};
